"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceResponseModelCategory = void 0;
exports.VoiceResponseModelCategory = {
    Generated: "generated",
    Cloned: "cloned",
    Premade: "premade",
    Professional: "professional",
    Famous: "famous",
    HighQuality: "high_quality",
};
